module.exports = __webpack_public_path__ + "fonts/4ff9f3fa-9221-4fc5-97e6-93572b6efa24.b731f7c.woff2";